export const styles = {
  root: {
    width: { xs: '100%', lg: '100%' },
    // minHeight: { xs: 'none', lg: 247 },
  },
  paper: { width: '100%', p: '16px 24px 24px', height: '100%' },
  day: {
    width: 'fit-content',
    backgroundColor: 'kit.background.purple',
    p: { xs: '2px 6px 5px 7px', md: '4px 8px 5px 8px' },
    borderRadius: 2,
  },
  points: {
    fontSize: { xs: 14, md: 16 },
    zIndex: 1,
    color: 'kit.text.secondary',
  },
  accordions: (isLastCard) => ({
    backgroundColor: isLastCard
      ? 'kit.background.middlepurple'
      : 'kit.background.white',
    '& .MuiAccordionSummary-root': {
      padding: '0px 24px 0px 8px',
    },
    '& .MuiAccordionDetails-root': {
      marginTop: -1.5,
      padding: '0px 16px 16px 16px',
    },
  }),
};
